import ContentDialogAlert from "features/shared/components/contentDialog/ContentDialogAlert";
import React from "react";
import { ContractingInfoSubDialogProps } from "features/contracting/models/ContractingInfoSubDialogProps";

const ContractingInfoSubDialog = ({
  type,
  message,
  primaryBtn,
  secondaryBtn,
}: ContractingInfoSubDialogProps) => {
  // sub-renders
  const renderButtons = () => {
    return (
      <>
        {renderSecondaryButton()}
        <button className="btn btn-primary" onClick={primaryBtn.action}>
          {primaryBtn.text}
        </button>
      </>
    );
  };

  const renderSecondaryButton = () => {
    if (secondaryBtn) {
      return (
        <button
          className="btn btn-outline-secondary mr-2"
          onClick={secondaryBtn.action}
        >
          {secondaryBtn.text}
        </button>
      );
    }
  };

  // render
  return (
    <div>
      <ContentDialogAlert
        alertObject={{
          alertType: type,
          message: message,
        }}
        actionBtns={renderButtons}
      />
    </div>
  );
};

export default ContractingInfoSubDialog;
